import { ColEntitlement } from "src/app/components/shared/home-searcher/data-table/ColEntitlement";

export class User {
  private name: string;
  private user: string;
  private token: string;
  private mail: string;

  private entitlement: ColEntitlement[];

  constructor() {
    // This is intentional
  }

  getName(): string {
    return this.name;
  }

  setName(name: string) {
    this.name = name;
  }

  getUser(): string {
    return this.user;
  }

  setUser(user: string) {
    this.user = user;
  }

  getToken(): string {
    return this.token;
  }

  setToken(token: string) {
    this.token = token;
  }

  getMail(): string {
    return this.mail;
  }

  setMail(mail: string) {
    this.mail = mail;
  }

  getEntitlement() {
    return this.entitlement;
  }

  setEntitlement(entitlement: ColEntitlement[]) {
    this.entitlement = entitlement;
  }

}
